angular.module('signalview.snapshot', [
    'signalview.snapshotSharing',
    'signalview.chart',
    'signalview.chartbuilder',
    'sfx.data',
    'sfx.api.v2',
    'signalview.urlOverrides',
]);
